<template>
  <div class="baseInfo-wrap">
    <div class="form-body">
      <Form :model="productForm" ref="productFormRef" class="page-form" :rules="productFormRules" :label-width="120">
        <FormItem label="产品编码" prop="productCode">
          <span v-show="showError" class="error">产品编码已存在，请重新录入</span>
          <Input
            :disabled="productForm.id != '' && productForm.id != undefined && !isCopy"
            type="text"
            v-model="productForm.productCode"
            @on-blur="checkProduct"
            placeholder="请输入"
          />
        </FormItem>
        <FormItem label="产品名称" prop="productName">
          <Input
            type="text"
            v-model="productForm.productName"
            @on-blur="
              event => {
                productForm.productName = event.target.value.trim();
              }
            "
            placeholder="请输入"
          />
        </FormItem>
        <FormItem label="供应商产品ID" prop="supplierProductId" v-if="$units.superviseShowVal()">
          <Input
            type="text"
            v-model="productForm.supplierProductId"
            @on-blur="
              event => {
                productForm.supplierProductId = event.target.value.trim();
              }
            "
            placeholder="请输入"
          />
        </FormItem>
        <FormItem label="保险公司" prop="companyCode">
          <Select
            :disabled="productForm.isImport == 1 && !isCopy"
            v-model="productForm.companyCode"
            placeholder="请选择保险公司"
            filterable
            clearable
            @on-change="getSupplierList"
          >
            <Option :value="company.code" v-for="company in companyList" :key="company.code" :item="company">{{ company.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="上架状态" prop="publishStatus">
          <RadioGroup v-model="productForm.publishStatus">
            <Radio label="2">已上架</Radio>
            <Radio label="1">已下架</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem v-if="productForm.sourceType == 2 || !productForm.id" label="销售状态" prop="salesStatus">
          <RadioGroup v-model="productForm.salesStatus">
            <Radio label="2">在售</Radio>
            <Radio label="1">停售</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="主附险类型" prop="productMainType">
          <RadioGroup v-model="productForm.productMainType">
            <Radio label="1">主险</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="产品类型标记" prop="productCategory" :rules="$units.formRule.required('请选择产品类型标记')">
          <Select
            :disabled="productForm.id != '' && productForm.id != undefined"
            v-model="productForm.productCategory"
            placeholder="请选择产品类型标记"
            filterable
            clearable
          >
            <Option value="3">个险</Option>
            <Option value="1">团险</Option>
            <Option value="2">财产险</Option>
          </Select>
        </FormItem>
        <FormItem label="险种分类" prop="themeIds" :rules="$units.formRule.arrRequired('请选择险种分类', 'change')">
          <selectTree
            :data="productThemeJoinVOS"
            :multiple="true"
            :size="null"
            placeholder="请选择险种分类"
            :single="true"
            :showParentNode="true"
            :selectAllChildren="false"
            @check="changeThemeIds($event, 1)"
            v-model="productForm.themeIds"
          >
          </selectTree>
        </FormItem>
        <FormItem label="监管分类" prop="regulatoryThemeId" :rules="$units.formRule.arrRequired('请选择监管分类', 'change')">
          <selectTree
            :data="productCategoryList"
            :multiple="false"
            :size="null"
            placeholder="请选择监管分类"
            :single="true"
            :showParentNode="true"
            :selectAllChildren="false"
            @onChange="productCategoryChange"
            v-model="productForm.regulatoryThemeId"
          ></selectTree>
        </FormItem>
        <FormItem label="长短险标志" prop="productType">
          <RadioGroup v-model="productForm.productType" @on-change="productTypeChange">
            <Radio label="1">长险</Radio>
            <Radio label="2">短险</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否含身故" prop="includingDeath">
          <Select v-model="productForm.includingDeath" placeholder="请选择是否含身故" filterable clearable>
            <Option :value="1">含身故</Option>
            <Option :value="0">不含身故</Option>
          </Select>
        </FormItem>

        <FormItem class="flex" label="供应商" prop="supplierType" v-if="$units.superviseShowVal()">
          <Select v-model="productForm.supplierType" placeholder="请选择供应商类型" @on-change="getSupplierList">
            <Option value="1">保司</Option>
            <Option value="2">通道</Option>
          </Select>
          <Select class="m-4" v-model="productForm.supplierId" placeholder="请选择供应商" @on-change="getSupplierId" clearable filterable>
            <Option :value="item.id" v-for="item in supplierList" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="productForm.id" key="hasCovenant" label="是否有代理协议" prop="hasCovenant" :rules="$units.formRule.required('请选择是否有代理协议')">
          <span v-if="productForm.hasCovenant == 1">是</span>
          <span v-else>否</span>
        </FormItem>
        <FormItem label="展业端分类" prop="showThemeIds">
          <selectTree
            :data="productBusinessList"
            :multiple="true"
            :size="null"
            placeholder="请选择险种分类"
            :single="true"
            :showParentNode="true"
            :selectAllChildren="false"
            @check="changeThemeIds($event, 2)"
            v-model="productForm.showThemeIds"
          >
          </selectTree>
        </FormItem>
        <FormItem label="基础销量" prop="baseSalesNum" :rules="$units.formRule.number(false)">
          <Input
            type="text"
            :maxlength="11"
            v-model="productForm.baseSalesNum"
            @on-blur="
              event => {
                productForm.baseSalesNum = event.target.value.trim();
              }
            "
            placeholder="请输入"
          />
        </FormItem>
        <FormItem class="flex" label="最低保费" prop="insureCost">
          <Input
            type="text"
            v-model="productForm.insureCost"
            @on-blur="
              event => {
                productForm.insureCost = event.target.value.trim();
              }
            "
            placeholder="请输入"
          />
          <span class="m-4">元起</span>
        </FormItem>
        <FormItem class="ivu-form-item-required" label="是否代收保费" prop="isCollection">
          <RadioGroup v-model="productForm.isCollection">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="生效天数" prop="effectiveDay">
          <Input
            type="text"
            v-model="productForm.effectiveDay"
            @on-blur="
              event => {
                productForm.effectiveDay = event.target.value.trim();
              }
            "
            placeholder="请输入"
          />
        </FormItem>
        <FormItem label="是否需要回执" prop="isReceipt">
          <RadioGroup v-model="productForm.isReceipt" @on-change="changeIsReceipt">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem class="flex" label="犹豫期" prop="hesitateTime">
          <Select v-model="productForm.hesitateType" placeholder="请选择犹豫期" clearable>
            <Option v-if="productForm.isReceipt != 0" value="1">回执当日起</Option>
            <Option v-if="productForm.isReceipt != 0" value="2">回执次日起</Option>
            <Option value="3">生效日期起</Option>
          </Select>
          <Input
            class="m-4"
            type="text"
            v-model="productForm.hesitateTime"
            @on-blur="
              event => {
                productForm.hesitateTime = event.target.value.trim();
              }
            "
            placeholder="请输入"
          />
          <span>自然日</span>
        </FormItem>
        <FormItem label="是否需要回访" prop="returnVisit">
          <RadioGroup v-model="productForm.returnVisit">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="期数" prop="commissionNum">
          <Input
            :disabled="productForm.id != '' && productForm.id != undefined && !isCopy"
            type="number"
            v-model="productForm.commissionNum"
            placeholder="请输入"
            @on-blur="
              event => {
                event.target.value != '' ? (productForm.commissionNum = Number(event.target.value)) : '';
              }
            "
          />
        </FormItem>
        <FormItem label="是否可续保" prop="isRenewal" key="isRenewal" v-if="productForm.productType == 2">
          <RadioGroup v-model="productForm.isRenewal">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="续保提前期限"
          prop="advancePeriod"
          key="advancePeriod"
          v-if="productForm.isRenewal == 1 && productForm.productType == 2"
          :rules="$units.formRule.num('请输入续保提前期限')"
        >
          <Input
            type="number"
            v-model="productForm.advancePeriod"
            placeholder="请输入"
            @on-blur="
              event => {
                event.target.value !== '' ? (productForm.advancePeriod = Number(event.target.value)) : '';
              }
            "
          >
            <span slot="append">天</span>
          </Input>
        </FormItem>
        <FormItem
          label="续保延期期限"
          prop="delayPeriod"
          key="delayPeriod"
          v-if="productForm.isRenewal == 1 && productForm.productType == 2"
          :rules="$units.formRule.num('请输入续保延期期限')"
        >
          <Input
            type="number"
            v-model="productForm.delayPeriod"
            placeholder="请输入"
            @on-blur="
              event => {
                event.target.value !== '' ? (productForm.delayPeriod = Number(event.target.value)) : '';
              }
            "
          >
            <span slot="append">天</span>
          </Input>
        </FormItem>
        <FormItem label="监管报备" prop="supervise" key="supervise" v-if="$units.superviseShowVal()">
          <RadioGroup v-model="productForm.supervise">
            <Radio label="0">否</Radio>
            <Radio label="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <Divider />
        <div class="title">档次/计划</div>
        <gradeAdditionsTable :productForm="productForm" :gradeAdditions="gradeAdditions" :additionals="additionals"/>

        <Divider />
        <div class="title">双主险/附加险</div>
        <div class="btn-wrap">
          <Button type="primary" @click="editProductOpen({}, 1)">新增双主险</Button>
          <Button type="primary" @click="$refs.editAdditionProduct.open({}, 1)">新增附加险</Button>
        </div>
        <Table :columns="columns1" :data="additionals">
          <template slot-scope="{ row, index }" slot="action">
            <span class="table-btn" @click="row.type == 1 ? $refs.editAdditionProduct.open(row, 2, index) : editProductOpen(row, 2, index)">编辑</span>
            <span class="table-btn red" @click="deleteAddtionPro(row, index)">删除</span>
          </template>
        </Table>

        <Divider />
        <div class="title">销售信息</div>
        <FormItem label="业务类别" prop="sellTypeOne" key="sellTypeOne">
          <Select v-model="productForm.sellTypeOne" placeholder="请选择业务类别" key="sellType" clearable>
            <Option value="1">网销产品</Option>
            <Option value="3">经代产品</Option>
          </Select>
        </FormItem>
        <FormItem label="投保方式" prop="insureType" :rules="$units.formRule.arrRequired('请选择投保方式', 'change')">
          <Select v-model="productForm.insureType" multiple placeholder="请选择投保方式" key="insureType">
            <Option value="1">自投</Option>
            <Option value="2">代投</Option>
            <Option value="4">预约</Option>
          </Select>
        </FormItem>
        <FormItem label="区域">
          <select-region v-model="regionSelectIds" :checkAllData="true" @init="regionInit" @change="regionChange"></select-region>
        </FormItem>
        <!-- 预约投保配置 -->
        <template v-if="productForm.insureType && productForm.insureType.includes('4')">
          <FormItem class="full upload-item" label="咨询名片" prop="appointConsultUrl" :rules="$units.formRule.arrRequired('请上传咨询名片', 'change')">
            <upLoad :arr="productForm.appointConsultUrl" @upload="file => upLoadImg(file, 'appointConsultUrl')" tip="支持JPG、JPEG或PNG格式，图宽为750px">
            </upLoad>
          </FormItem>
        </template>
        <!-- 自投或代投 -->
        <template v-if="productForm.insureType && (productForm.insureType.includes('1') || productForm.insureType.includes('2'))">
          <FormItem class="full" label="投保通道类型" prop="insuranceType">
            <RadioGroup v-model="productForm.insuranceType">
              <Radio label="1">h5链接</Radio>
              <Radio label="2">api在线投保</Radio>
              <span v-show="productForm.insuranceType === '2'" class="c-red">还未对接api，不可投保。您可联系商务经理申请对接</span>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="productForm.insuranceType == 1" label="投保链接地址" prop="insureUrl" class="full">
            <Input type="textarea" v-model="productForm.insureUrl" placeholder="如需投保必须填写链接地址" />
            <product-link :link="productForm.insureUrl"></product-link>
          </FormItem>
        </template>
        <FormItem label="计划书地址" prop="planUrl" class="full">
          <Input type="textarea" v-model="productForm.planUrl" placeholder="请输入" />
        </FormItem>
        <Divider />
        <div class="title">备案信息</div>
        <div class="btn-wrap">
          <Button type="primary" @click="editRemark({}, 1, 0)">新增</Button>
        </div>
        <Table :columns="columns2" :data="filingInformations">
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <div @click="editRemark(row, 2, index)">
                <span>编辑</span>
              </div>
            </div>
            <div class="detail">
              <div @click="deleteRemark(row, index)">
                <span>删除</span>
              </div>
            </div>
          </template>
        </Table>
      </Form>
    </div>
    <coverPopup ref="coverPopup" :productCoverList="productCoverList" @success="url => (productForm.mobileCover = url.coverUrl)"> </coverPopup>
    <remarkModal ref="remarkModal" @success="getFilingInformations"></remarkModal>
    <editAdditionProduct
      :additionals="additionals"
      :gradeAdditions="gradeAdditions"
      :productCode="productForm.productCode"
      ref="editAdditionProduct"
      @success="getAdditionList"
    >
    </editAdditionProduct>
    <editProduct :additionals="additionals" :productList="productList" :productCode="productForm.productCode" ref="editProduct" @success="getAdditionList">
    </editProduct>
  </div>
</template>

<script>
var vm;
import { uploadFile } from '@/api/httpList';
import upLoad from './upload';
import remarkModal from './remarkModal';
import coverPopup from './coverPopup';
import productLink from './productLink';
import editProduct from './editProduct';
import gradeAdditionsTable from './gradeAdditionsTable';
import addTag from '@/components/commons/addTag';
import editAdditionProduct from './editAdditionProduct';
import selectTree from '@/components/commons/selectTree';
import selectRegion from '@/components/commons/selectRegion';
import { productEditMixin } from '../form/productEditMixin';
export default {
  components: {
    gradeAdditionsTable,
    selectRegion,
    productLink,
    upLoad,
    selectTree,
    addTag,
    editProduct,
    remarkModal,
    editAdditionProduct,
    coverPopup
  },
  name: 'baseInfo',
  props: ['additionals', 'filingInformations', 'gradeAdditions'],
  mixins: [productEditMixin],
  data() {
    return {
      formData: {},
      initProductCode: '', //初始productCode
      supplierList: [],
      showError: false,
      // 产品分类
      ProductThemeList: [],
      productCategoryList: [],
      productBusinessList: [],
      productThemeJoinVOS: [],
      productList: [],
      columns1: [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '险种code',
          key: 'addCode',
          align: 'center',
          minWidth: 130
        },
        {
          title: '主附险类型',
          slot: 'type',
          align: 'center',
          minWidth: 300,
          render(h, params) {
            return <span>{params.row.type == 1 ? '附加险' : '主险'}</span>;
          }
        },
        {
          title: '产品名称',
          key: 'addName',
          align: 'center',
          minWidth: 300
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '130',
          fixed: 'right'
        }
      ],
      columns2: [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '备案名称',
          key: 'name',
          align: 'center',
          minWidth: 130
        },
        {
          title: '批复文号/备案编号/产品注册号',
          key: 'filingNumber',
          align: 'center',
          minWidth: 300
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '130',
          fixed: 'right'
        }
      ],
      productForm: {},
      isCopy: false, //复制产品
      visible: false,
      productCoverList: [], //素材封面列表
      regionData: [], //初始化的区域数据
      regionSelectData: [], //选择的区域数据
      regionSelectIds: [] //选择的区域id
    };
  },
  created() {
    vm = this;
    // 产品分类
    this.queryProductClassification();
  },
  methods: {
    // 区域初始化
    regionInit(data) {
      this.regionData = data;
    },
    // 选择区域
    regionChange() {
      const data = JSON.parse(JSON.stringify(this.regionData));
      const out = [];
      data.forEach(item => {
        let hasAll = false;
        if (this.regionSelectIds.includes(item.value)) {
          hasAll = true;
        }
        if (item.children) {
          item.children.forEach(item2 => {
            if (this.regionSelectIds.includes(item2.value)) {
              const data = {
                cityCode: item2.value,
                cityName: item2.label
              };
              if (hasAll) {
                data.provinceCode = item.value;
                data.provinceName = item.label;
              }
              out.push(data);
            }
          });
        }
      });
      this.regionSelectData = out;
    },
    // 修改长短险
    productTypeChange() {
      if (this.productForm.productType == 1) {
        this.productForm.isRenewal = '';
        this.productForm.advancePeriod = '';
        this.productForm.delayPeriod = '';
      } else if (this.productForm.productType == 2) {
        this.productForm.isRenewal = 1;
        this.productForm.advancePeriod = 30;
        this.productForm.delayPeriod = 0;
      }
    },
    getSupplierId(val) {
      if (this.productForm.supplierType == '1' && this.productForm.supplierId) {
        let item = this.supplierList.find(i => i.id == val);
        let id = item.parentId || item.id;
        this.productForm.companyCode = this.companyList.find(i => i.id == id).code;
      }
    },
    getSupplierList() {
      let data = {};
      let url = '';
      if (!this.productForm.supplierType) {
        this.supplierList = [];
        this.productForm.supplierId = '';
        return;
      } else if (this.productForm.supplierType == '2') {
        url = '/buz/insuranceChannel/read/list';
      } else if (this.productForm.supplierType == '1') {
        if (this.productForm.companyCode && this.companyList.find(i => i.code == this.productForm.companyCode)) {
          let id = this.companyList.find(i => i.code == this.productForm.companyCode).id;
          data = {
            headId: id
          };
        }
        url = '/buz/insuranceCompany/read/all';
      }
      this.$http({
        url,
        type: 'POST',
        data
      }).then(res => {
        this.supplierList = res.data || [];
      });
    },
    editProductOpen(...res) {
      console.log(res);
      let data = { pageNo: 1, pageSize: 99999 };
      if (this.productForm.productCode) {
        data.filterCodes = [this.productForm.productCode];
      }
      this.$http({
        url: '/buz/productBase/queryArray',
        type: 'POST',
        data
      }).then(res => {
        this.productList = res.data;
      });
      this.$refs.editProduct.open(...res);
    },
    changeIsReceipt(val) {
      if (val == 0) {
        this.productForm.hesitateType = '3';
      }
    },
    queryProductTheme() {
      this.$http({
        url: '/buz/productThemeJoin/queryProductTheme',
        type: 'GET',
        data: {}
      }).then(res => {
        this.productThemeJoinVOS = this.dealTree1(res.data);
      });
    },
    // 获取展业端类别
    queryBusinessClassification() {
      this.$http({
        url: '/buz/merchantProductThemeJoin/queryProductTheme',
        type: 'GET',
        data: {}
      }).then(res => {
        this.productBusinessList = this.dealTree2(res.data);
      });
    },
    async init(productForm = {}, isCopy = false, productInsureAreas = []) {
      this.productForm = productForm;
      this.isCopy = isCopy;
      this.showError = false;
      let res = await this.queryInsuranceCompany();
      this.companyList = res.data;
      this.getSupplierList();
      if (!this.productForm.id) {
        // this.getCover();
        this.queryProductTheme(); //查询默认产品分类
        this.queryBusinessClassification(); //展业端类别
      } else {
        this.initProductCode = JSON.parse(JSON.stringify(productForm.productCode));
        if (!productForm.mobileCover) {
          // this.getCover();
        }
        if (productForm.productThemeJoinVOS) {
          this.productThemeJoinVOS = this.dealTree1(productForm.productThemeJoinVOS);
        }
        if (productForm.productShowThemeJoinVOS) {
          this.productBusinessList = this.dealTree2(productForm.productShowThemeJoinVOS);
        }
        this.setRegionId(productInsureAreas);
        this.regionSelectData = productInsureAreas;
      }
      if (isCopy) {
        delete this.productForm.productCode;
        delete this.productForm.id;
        if (!this.productForm.insuranceType) {
          this.productForm.insuranceType = '1';
        }
        this.productForm.publishStatus = '1';
        this.productForm.salesStatus = '1';
      }

      return this.productForm;
    },
    // 设置回显的区域id
    setRegionId(productInsureAreas) {
      const regionSelectIds = [];
      productInsureAreas.forEach(item => {
        if (item.provinceCode && !regionSelectIds.includes(item.provinceCode)) {
          regionSelectIds.push(item.provinceCode);
        }
        if (item.cityCode) {
          regionSelectIds.push(item.cityCode);
        }
      });
      this.regionSelectIds = regionSelectIds;
    },
    //文件上传
    upLoadImg(file, key) {
      if (!file) {
        this.productForm[key] = '';
        this.$refs.productFormRef.validateField(key);
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData).then(res => {
        this.productForm[key] = res.data[0].path;
        this.$refs.productFormRef.validateField(key);
      });
    },
    checkProduct() {
      if (this.initProductCode == this.productForm.productCode.trim() && !this.isCopy) return;
      this.$http({
        url: '/buz/productBase/checkCode',
        type: 'GET',
        data: {
          productCode: this.productForm.productCode.trim()
        }
      }).then(res => {
        this.showError = !res.data;
      });
    },
    getFilingInformations(type, item, index = null) {
      if (type == 1) {
        this.filingInformations.push(item);
      } else {
        this.filingInformations[index].filingNumber = item.filingNumber;
        this.filingInformations[index].name = item.name;
      }
    },
    /**
     *
     * @param {*} type 1新增 2编辑
     * @param {*} item 选项
     */
    getAdditionList(type, item, index = null) {
      if (type == 1) {
        this.additionals.push(item);
      } else {
        this.additionals[index].addCode = item.addCode;
        this.additionals[index].addName = item.addName;
      }
      if (type == 1) {
        //新增
        this.$notice.success('新增成功');
      } else {
        //编辑
        this.$notice.success('修改成功');
      }
    },
    // 选择监管分类
    productCategoryChange(name, ids) {
      this.productForm.regulatoryThemeId = ids;
      this.productForm.regulatoryThemeStr = name.replaceAll('|', ',').replaceAll('/', '-');
    },
    /**
     * 修改险种分类 选择 一级菜单，取消/选择 所有二级菜单  ，  选择二级菜单  选择 一级菜单
     * 1.当前选择的是父级，所有子集同步父级状态
     * 2.当前选择的是子级
     * 2.1 如果是新增勾选节点父级也新增勾选，父级如果已勾选不处理
     * 2.2 如果是取消勾选节点且所有同级都是取消时父级也取消
     */
    changeThemeIds(data, type) {
      // 1.当前选择的是父级，所有子集同步父级状态
      const cur = data[0]; //当前点击节点
      const ids = data[1]; //当前选中的所有id
      let isAdd = ids.includes(cur.value); //是否是新增勾选
      cur.children &&
        cur.children.forEach(item => {
          const index = ids.indexOf(item.value);
          if (isAdd && index == -1) {
            //新增未勾选的节点
            ids.push(item.value);
          } else if (!isAdd && index != -1) {
            //删除已勾选的节点
            ids.splice(index, 1);
          }
        });
      // 2.当前选择的是子级，处理父级
      if (cur.parentId != '0') {
        // 2.1 如果是新增勾选节点父级也新增勾选，父级如果已勾选不处理
        if (isAdd && !ids.includes(cur.parentId)) {
          ids.push(cur.parentId);
        }
        // 2.2 如果是取消勾选节点且所有同级都是取消状态时父级也取消
        if (!isAdd) {
          let isCancelAll = true; //是否是取消所有子集
          let parentData = [];
          if (type == 1) {
            parentData = this.productThemeJoinVOS.find(item => item.value == cur.parentId);
          } else {
            parentData = this.productBusinessList.find(item => item.value == cur.parentId);
          }
          parentData.children.forEach(item => {
            if (ids.includes(item.value)) {
              isCancelAll = false;
            }
          });
          if (isCancelAll) {
            const index = ids.indexOf(cur.parentId);
            if (index != -1) {
              ids.splice(index, 1);
            }
          }
        }
      }
      if (type == 1) {
        this.productForm.themeIds = ids;
      } else {
        this.productForm.showThemeIds = ids;
      }
    },
    // 获取监管分类
    queryProductClassification() {
      this.$http({
        url: '/buz/productRegulatoryTheme/read/tree',
        type: 'GET'
      }).then(res => {
        this.productCategoryList = this.dealTree(res.data);
      });
    },
    dealTree1(arr) {
      return arr.map(item => {
        if (item.checked) this.productForm.themeIds.push(item.themeId);
        return {
          ...item,
          value: item.themeId,
          label: item.name,
          title: item.name,
          expand: true,
          children: item.child && item.child.length > 0 ? this.dealTree1(item.child, item.name) : null
        };
      });
    },
    dealTree2(arr) {
      return arr.map(item => {
        if (item.checked) this.productForm.showThemeIds.push(item.themeId);
        return {
          ...item,
          value: item.themeId,
          label: item.name,
          title: item.name,
          expand: true,
          children: item.child && item.child.length > 0 ? this.dealTree2(item.child, item.name) : null
        };
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        disabled: item.children && item.children.length ? true : false,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },
    //获取保司
    queryInsuranceCompany() {
      return this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: 1
        }
      });
    },
    // sellTypeChange() {
    //     const sellTypeOne = this.productForm.sellTypeOne;
    //     const insureType = this.productForm.insureType;
    //     if(!sellTypeOne) {
    //         this.productForm.insureType = [];
    //     } else if (sellTypeOne==1) {
    //         // 网销去掉代投
    //         this.productForm.insureType = insureType.filter(item=>item!='2')
    //     }
    // },
    editRemark(row = {}, editType, index = null) {
      this.$refs.remarkModal.open(row, editType, index);
    },
    deleteRemark(row, index) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        if (row.id && this.productForm.id) {
          this.$http({
            url: `/buz/endorsement/cancel`,
            type: 'POST',
            data: {
              businessNo: row.id
            }
          }).then(res => {
            this.$notice.success('操作成功');
            this.initListAjax('/buz/endorsement/read/list');
          });
        } else {
          this.filingInformations.splice(index, 1);
        }
      });
    },
    deleteAddtionPro(row, index) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        if (row.id && this.productForm.id) {
          this.$http({
            url: `/buz/productAdditional/checkDel`,
            type: 'GET',
            data: {
              id: row.id
            }
          }).then(res => {
            if (res.data) {
              this.additionals.splice(index, 1);
            } else {
              this.$notice.error(row.type == 1 ? '当前附加险已经配置费用，无法删除！' : '当前主险已经配置费用，无法删除！');
            }
          });
        } else {
          this.additionals.splice(index, 1);
        }
      });
    },
    // 验证
    checkForm() {
      return new Promise((resolve, reject) => {
        if (this.showError) {
          reject({ selTab: '1' });
          return;
        }
        this.$refs.productFormRef.validate(async valid => {
          if (valid) {
            let data = {};
            let productForm = JSON.parse(JSON.stringify(this.productForm));
            productForm.regulatoryThemeId =
              productForm.regulatoryThemeId && productForm.regulatoryThemeId.length ? productForm.regulatoryThemeId.join(',') : '';

            if (!productForm.commissionNum) {
              productForm.commissionNum = 0;
            }
            productForm.sellType = JSON.stringify([productForm.sellTypeOne]);
            productForm.insureType = JSON.stringify(productForm.insureType);
            if (!productForm.id) {
              delete productForm.id;
            }
            if (productForm.goodness) {
              productForm.goodness = productForm.goodness.join('\n');
            }
            delete productForm.subordinateSettleRule;
            delete productForm.settleRule;
            data = {
              productBase: productForm,
              additionals: this.additionals,
              gradeAdditions: this.gradeAdditions,
              filingInformations: this.filingInformations
            };
            if (this.isCopy) {
              data.isCopy = '1';
              data.productBase.isImport = '0';
              data.copyProductCode = this.initProductCode;
            }
            delete data.productBase.createTime;
            delete data.productBase.updateTime;
            data.additionals.forEach(item => {
              delete item.createTime;
              delete item.updateTime;
            });
            data.gradeAdditions.forEach(item => {
              delete item.createTime;
              delete item.updateTime;
            });
            data.filingInformations.forEach(item => {
              delete item.createTime;
              delete item.updateTime;
            });
            resolve(data);
          } else {
            this.$notice.error('请正确填写表单');
            reject({ selTab: '1' });
          }
        });
      });
    },
    // 提交数据，父级调用
    async saveForm(formData, notice, callback) {
      formData.productInsureAreas = this.regionSelectData;
      if (this.isCopy) {
        await this.getProductProcess(formData);
        formData.productInsureAreas.forEach(item => {
          delete item.id;
          item.productCode = this.productForm.productCode;
        });
      }
      return this.$http({
        url: this.productForm.id ? '/buz/productBase/edit/v2' : '/buz/productBase/offline/add',
        type: 'POST',
        data: formData,
        apiPermissionCode: 'pro_2_1'
      }).then(res => {
        notice ? this.$notice.success('保存成功') : '';
        if (!this.productForm.id) {
          this.productForm.productCode = res.data.productCode;
          this.productForm.id = res.data.id;
          this.productForm.issaveFormImport = '0';
          this.productForm.hasCovenant = '0';
          this.productForm.sourceType = res.data.sourceType;
          this.productForm.insuranceType = res.data.insuranceType;
          this.initProductCode = res.data.productCode;
        }
        if (this.isCopy) {
          this.$emit('success', res.data);
        } else {
          this.$emit('success', {
            id: this.productForm.id
          });
        }
        if (callback) callback(res.data && res.data.id ? res.data : {});
      });
    },
    // 获取投保流程
    getProductProcess(formData) {
      return this.$http({
        url: '/buz/productInsureProfile/offline/list',
        type: 'GET',
        data: {
          productCode: this.initProductCode
        }
      }).then(res => {
        res.data.forEach(item => {
          delete item.id;
          item.productCode = this.productForm.productCode;
        });
        formData.productInsureProfile = res.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.example-img {
  max-width: 800px;
  max-height: 200px;
}

.baseInfo-wrap {
  /deep/.ivu-icon-ios-help-circle-outline {
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    margin-left: 4px;
  }

  .ivu-divider-horizontal {
    margin: 15px 0;
  }

  /deep/.ivu-icon-ios-create-outline {
    font-size: 16px;
    margin-right: 4px;
    cursor: pointer;
    font-weight: 600;
  }

  /deep/.upload-item {
    margin-bottom: 30px;

    .ivu-form-item-error-tip {
      top: unset;
      bottom: -30px;
    }

    .ivu-form-item-content {
      display: flex;
      width: calc(100% - 400px);
      align-items: center;

      .wrapper {
        flex-direction: column;
      }

      .ivu-btn {
        margin-left: 10px;
      }
    }
  }

  /deep/.error {
    color: #ed4014;
    font-size: 13px;
    position: absolute;
    bottom: -28px;
  }

  /deep/.flex .ivu-form-item-content {
    display: flex;
    white-space: nowrap;
  }

  .c-red {
    color: #ed4014;
    font-size: 13px;
  }

  /deep/.m-4 {
    margin: 0 4px;
  }

  .title {
    font-weight: 800;
    margin-bottom: 15px;
  }

  .btn-wrap {
    margin: 15px 0;
  }
}
</style>